
import {computed, ComputedRef, defineComponent, onMounted, Ref, ref, watch} from 'vue'
import {useStore} from 'vuex'
import {useI18n} from 'vue-i18n'

import {EChartsOption} from 'echarts'

import useEcharts from '@/composables/useEcharts'

import {StateType as HomeStateType} from '../../store'
import {ChartDataType} from '../../data'

const linksChartOption: EChartsOption = {
  title: {
    text: 'ECharts',
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  xAxis: [
    {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      axisTick: {
        alignWithLabel: true,
      },
    },
  ],
  yAxis: [
    {
      type: 'value',
    },
  ],
  series: [
    {
      name: 'Direct',
      type: 'bar',
      barWidth: '60%',
      data: [0, 100, 200, 300, 400],
    },
  ],
}

interface LinksChartCardSetupData {
  linksChartRef: Ref
  destination: Ref<string>
  productType: Ref<string>
}

// Y轴默认最大值
const DEFAULT_Y_MAX_VALUE = 10

export default defineComponent({
  name: 'LinksChartCard',
  props: {
    timeInfo: Object,
  },
  setup(props, {emit}): LinksChartCardSetupData {
    const store = useStore<{Home: HomeStateType}>()
    const destination = ref<string>('')
    const productType = ref<string>('')

    // console.log('seriesData',seriesData)
    // echarts 图表
    const linksChartRef = ref<HTMLDivElement>()
    const echarts = useEcharts(linksChartRef, linksChartOption)
    watch([echarts,props], () => {

      let seriesData = ref<any>([])
      let xAxisData = ref<any>([])

      let yAxisMaxValue = 0

      const newTimeInfo = new Array(props.timeInfo)
      newTimeInfo.map((item: any) => {
        destination.value = item[0].destination
        productType.value = item[0].productType
        item.map((s: any) => {
          seriesData.value.push(s.orderNum)
          xAxisData.value.push(s.deliveredCycle)

          if (s.orderNum > yAxisMaxValue) {
            yAxisMaxValue = s.orderNum
          }
        })
      })



      const axis = {
        nameTextStyle: {
          color: '#ccc',
        },
        /* axisLabel: {
         *   show: true,
         *   color: 'blue',
         * }, */
        axisLine: {
          show: true,
          lineStyle: {
            color: '#55555',
          },
        },
        axisTick: {
          show: true,
          lineStyle: {
            color: '#55555',
          },
        },
      }

      // TODO improve
      const defaultItemStyle = {
        color: '#1964a6',
        shadowColor: '#1964a6',
        borderType: 'dashed',
        opacity: 1,
      }
      let maxVal = 0
      let maxIdx = 0
      const displayData: any[] = []
      seriesData.value.forEach((value, idx) => {
        displayData.push({value, itemStyle: {...defaultItemStyle}})

        if (value > maxVal) {
          maxVal = value
          maxIdx = idx
        }
      })
      displayData[maxIdx].itemStyle.color = 'orange'

      if (echarts.value) {
        const yAxis: any[] = [
          {
            name: '单量',
            type: 'value',
            // max: yAxisMaxValue,
            minInterval: 1,
            ...axis,
          },
        ]
        // 若单量小于默认值, 则Y轴max取默认值; 否则, 不设置
        if (yAxisMaxValue < DEFAULT_Y_MAX_VALUE) {
          yAxis[0]['max'] = DEFAULT_Y_MAX_VALUE
        }

        const option: EChartsOption = {
          title: {
            text: destination.value + `(${productType.value == '1' ? '标准' : ''})`,
            left: 'center',
            textStyle: {
              color: '#ccc',
            },
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
          },
          grid: {
            /* left: '3%',
             * right: '5%',
             * bottom: '3%', */
            containLabel: true,
          },
          xAxis: [
            {
              name: '天',
              nameGap: 0,
              type: 'category',
              data: xAxisData.value,
              ...axis,
            },
          ],
          yAxis,
          series: [
            {
              name: 'Direct',
              type: 'bar',
              barWidth: '60%',
              // data: seriesData.value,
              data: displayData,
              itemStyle: {
                color: '#1964a6',
                shadowColor: '#1964a6',
                borderType: 'dashed',
                opacity: 1,
              },
              label: {
                show: true,
                position: 'top',
              },
            },
          ],
        }

        echarts.value.setOption(option)
      }
    })

    onMounted(() => {})

    return {
      linksChartRef,
      destination,
      productType,
    }
  }
})
